// extracted by mini-css-extract-plugin
export default {"position-page":"PositionPage_position-page__Jcj0L","positions-title":"PositionPage_positions-title__Pauwv"};